import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RestricaoFullResumo } from "./RestricaoFullResumo";

export default function RestricaoFullPF({ restricaoFullPf }: { restricaoFullPf: any }) {
  const cadastrais = restricaoFullPf?.dados_cadastrais;
  const participacaoSocietaria = restricaoFullPf?.participacao_societaria?.registro || [];

  return (
    <div>
      {restricaoFullPf?.mensagemErro ? (<p>{restricaoFullPf.mensagemErro}</p>) : (<>
        {cadastrais && (
          <div>
            <br />
            <Panel header="Dados Cadastrais">
              <div className="flex-consulta flex-wrap gap-3">
                <div><b>CPF:</b> {cadastrais.cpf}</div>
                <div><b>Nome:</b> {cadastrais.nome}</div>
                <div><b>Nascimento:</b> {cadastrais.data_nascimento}</div>
                <div><b>Nome da Mãe:</b> {cadastrais.nome_mae}</div>
                <div><b>Situação:</b> {cadastrais.situacao}</div>
                {cadastrais.data_situacao && (<div><b>Dt. Situação:</b> {cadastrais.data_situacao}</div>)}
              </div>
            </Panel>
          </div>
        )}
        <RestricaoFullResumo dados={restricaoFullPf} />
        {participacaoSocietaria.length > 0 && (
          <div>
            <br />
            <Panel header="Participação Societária">
              <DataTable size="small" value={participacaoSocietaria} tableStyle={{ minWidth: "50rem" }}>
                <Column field="cnpj" header="CNPJ"></Column>
                <Column field="razao_social" header="Razão Social"></Column>
                <Column field="uf" header="UF"></Column>
                <Column field="situacao" header="Situação"></Column>
                <Column field="data_situacao" header="Dt. Situação"></Column>
                <Column field="percentual" header="Percentual"></Column>
              </DataTable>
            </Panel>
          </div>
        )}
      </>)}
    </div>
  );
}
